import { z } from "zod";

export const listAdminUsersQuerySchema = z.object({
	limit: z.coerce.number().int().min(1).max(200).default(50),
	offset: z.coerce.number().int().min(0).default(0),
	q: z.string().trim().max(100).optional(),
	banned: z.coerce.boolean().optional(),
});
export type ListAdminUsersQuery = z.infer<typeof listAdminUsersQuerySchema>;
